module.exports = __webpack_public_path__ + "img/roller.bd3c217.png";